export const AUTHENTICATION_CHECK = 'AUTHENTICATION_CHECK'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE'
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_REQUEST_FAILURE = 'LOGOUT_REQUEST_FAILURE'
export const LOGOUT_REQUEST_SUCCESS = 'LOGOUT_REQUEST_SUCCESS'

export const PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST = 'PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST'
export const PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_FAILURE =
  'PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_FAILURE'
export const PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_SUCCESS =
  'PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_SUCCESS'

export const PROJECT_BOARD_SET_SORT_BY = 'PROJECT_BOARD_SET_SORT_BY'

export const FILTER_REQUEST = 'FILTER_REQUEST'
export const FILTER_REQUEST_FAILURE = 'FILTER_REQUEST_FAILURE'
export const FILTER_REQUEST_SUCCESS = 'FILTER_REQUEST_SUCCESS'

export const FILTER_SELECTION_REQUEST = 'FILTER_SELECTION_REQUEST'
export const FILTER_SELECTION_REQUEST_ALL = 'FILTER_SELECTION_REQUEST_ALL'
export const FILTER_DESELECTION_REQUEST_ALL = 'FILTER_DESELECTION_REQUEST_ALL'
export const FILTER_SELECTION_REQUEST_ALL_DESELECT = 'FILTER_SELECTION_REQUEST_ALL_DESELECT'

export const LISTING_PROJECT_REQUEST = 'LISTING_PROJECT_REQUEST'
export const LISTING_PROJECT_REQUEST_FAILURE = 'LISTING_PROJECT_REQUEST_FAILURE'
export const LISTING_PROJECT_REQUEST_SUCCESS = 'LISTING_PROJECT_REQUEST_SUCCESS'

export const RESET_REDUX = 'RESET_REDUX'
export const VIEW_FILTERS_MOBILE = 'VIEW_FILTERS_MOBILE'
export const HIDE_FILTERS_MOBILE = 'HIDE_FILTERS_MOBILE'
